import { Controller } from "@hotwired/stimulus"
import { destroy } from "@rails/request.js"

export default class extends Controller {
  static values = {url: String}

  async delete(event) {
    const response = await destroy(this.urlValue, {
      headers: {
        'Accept': 'text/vnd.turbo-stream.html'
      }
    })
    
    if (response.ok) {
      document.getElementById('form_filtra_materia').requestSubmit()
    }
  }
}
